import Event from '../domain/Event.js';

class ResetPasswordHandler {

  constructor(controller, emailAddressValidator, requestBuilder, httpService, trackingService) {

    this.controller = controller;
    this.emailAddressValidator = emailAddressValidator;
    this.requestBuilder = requestBuilder;
    this.httpService = httpService;
    this.trackingService = trackingService;

  }

  handleSubmit(emailAddress) {

    this.controller.startActionInProgress();

    this.emailAddressValidator.validate(emailAddress);

    let requestResetPasswordEmailRequest = this.requestBuilder.getRequestResetPasswordEmailRequest(emailAddress);

    return this.httpService.get(requestResetPasswordEmailRequest)
      .then((data) => {
        this.trackingService.submitEvent(Event.PASSWORD_RECOVERY_SUBMISSION);
        this.controller.showResetPasswordConfirmationPage(data);

        return data;
      });

  }

}

export default ResetPasswordHandler;



// WEBPACK FOOTER //
// ./src/library/handlers/ResetPasswordHandler.js